export interface TradingActivitiesReportData {
  id?: number;
  closePrice: number;
  closeTime: string;
  commissionUSD: number;
  paidCashback?: number;
  login: number;
  lot: number;
  openPrice: number;
  openTime: string;
  order: number;
  partnershipCode: string;
  profitUSD: number;
  sl: number;
  swapUSD: number;
  symbol: string;
  tp: number;
  type: string;
  volumeUSD: number;
}

export interface TradingActivitiesReportAggregate {
  totalLot: number;
  totalVolumeUSD: number;
  totalCommissionUSD: number;
  totalProfitUSD: number;
  totalVolumeUSDPercentage?: number | null;
  totalCommissionUSDPercentage?: number | null;
  totalProfitUSDPercentage?: number | null;
}

export interface TradingActivitiesReportResponse {
  items: TradingActivitiesReportData[];
  aggregate: TradingActivitiesReportAggregate;
  total: number;
}

export interface TradingRequestModel {
  partnershipCodes: string[];
  login: string[];
  fromDate: string;
  toDate: string;
  pageNumber: number;
}

export interface TradingActivitiesEmailReportRequest {
  reportPartnershipClientsTradingRequest: TradingRequestModel;
  reportEmailRequest: {
    email: null | string;
    includeTotal: boolean;
    tableColumns: string[];
    translatedTableColumns: string[];
    startDate: string;
    endDate: string;
  };
}

export const reportEnColumns = ['order', 'login', 'partnership', 'open time', 'type', 'symbol', 'lot', 'volume usd', 'open price', 'close time', 'close price', 'sl', 'tp', 'commission usd', 'swap usd', 'profit usd'];
